import requests from "./httpService";

const CashPassbookViewerServices = {
  getStores: async () => {
    return requests.get("/cash-passbook-viewer/stores");
  },

  getPassbooks: async (storeId) => {
    const params = new URLSearchParams({
      storeId
    });

    return requests.get(
      `/cash-passbook-viewer/passbooks?${params.toString()}`
    );
  },


  getPassbookDetails: async (id, filters = {}) => {
    const params = new URLSearchParams();

    [
      "storeId",
      "entryType",
      "status",
      "categoryId",
      "vendorId",
      "search",
      "fromDate",
      "toDate",
      "page",
      "limit"
    ].forEach((key) => {
      const value = filters[key];

      if (
        value !== undefined &&
        value !== null &&
        value !== ""
      ) {
        params.set(key, String(value));
      }
    });

    const query = params.toString();

    return requests.get(
      `/cash-passbook-viewer/passbooks/${encodeURIComponent(
        id
      )}${query ? `?${query}` : ""}`
    );
  },

};

export default CashPassbookViewerServices;